function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2795 1.73212C41.3188 10.1849 39.4308 18.8224 34.9677 26.08C30.5623 33.2336 23.6512 38.6494 15.7123 41.3688C11.1972 42.9162 6.49741 43.609 1.73407 43.3781C0.798729 43.3319 0.00195312 44.2037 0.00195312 45.1102C0.00195312 46.086 0.798729 46.7961 1.73407 46.8423C10.77 47.2811 19.9618 44.5213 27.2944 39.2383C34.7887 33.8399 40.1756 25.9703 42.5948 17.0614C43.9459 12.0902 44.3673 6.84765 43.738 1.73212C43.6225 0.802549 43.0221 0 42.0059 0C41.1629 0 40.1641 0.796775 40.2795 1.73212Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.20055 45.1102C7.47425 40.3122 10.7422 35.5085 14.0159 30.7105C14.5413 29.9368 14.1602 28.7878 13.3923 28.3433C12.5378 27.841 11.5505 28.1874 11.0251 28.9668C7.75139 33.7648 4.48346 38.5686 1.20975 43.3665C0.684341 44.1402 1.06541 45.2892 1.83331 45.7338C2.68783 46.2303 3.66936 45.8839 4.20055 45.1102Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.59591 48.2395C5.36039 52.183 9.63295 55.6357 14.2577 58.511C15.0545 59.0018 16.163 58.6842 16.6249 57.8875C17.1099 57.0618 16.7982 56.011 16.0014 55.5202C11.6076 52.7893 7.62369 49.5386 4.04398 45.7915C3.39732 45.116 2.24257 45.139 1.59591 45.7915C0.914611 46.467 0.943479 47.5582 1.59591 48.2395Z",
  fill: "white"
});

var SvgRightDerp = function SvgRightDerp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 59,
    viewBox: "0 0 45 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightDerp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-derp.3f0ec915.svg";
export { ForwardRef as ReactComponent };